const parseFontUrl = url => {
  const chunks = url.toString().split(/\//g);
  const [fontName, fontExtension] = chunks[chunks.length - 1].split(/\./);

  const fontFormat = {
    ttf: 'truetype',
    otf: 'opentype',
  }[fontExtension];

  return {
    fontName,
    fontExtension,
    fontFormat,
  };
};

export default parseFontUrl;
